// extracted by mini-css-extract-plugin
export default {"formContainer":"ClientForm_formContainer__w0VgQ","bannersContainer":"ClientForm_bannersContainer__odBgi","banner":"ClientForm_banner__sYLZi"};